import config from '../../config'
import {
  valid,
  refreshToken,
  ajax,
  serviceAjax,
  header
} from './base'

const product = {

  async BatchEditCategory(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/BatchEditCategory',
      type: 'post',
      data
    })
    return response
  },
  // 分类
  async GetCategoryList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductCategory/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetCategory(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductCategory/GetById',
      type: 'get',
      data
    })
    return response
  },
  async AddOrUpdateCategory(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductCategory/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async DelCategory(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductCategory/Delete',
      type: 'post',
      data
    })
    return response
  },
  async GetForSelectCategory(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductCategory/GetForSelect',
      type: 'get',
      data
    })
    return response
  },
  async GetAllProductCategoryForCascader(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductCategory/GetAllForCascader',
      type: 'get',
      data
    })
    return response
  },
  // 产品
  async GetInventory(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/GetInventory',
      type: 'post',
      data
    })
    return response
  },

  async SetProductOnlyOrder(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/IsOnlyOrder',
      type: 'post',
      data
    })
    return response
  },
  async GetProductList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetProductSelectList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/GetSelectPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetProductOrgList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/GetProductOrgPaged',
      type: 'get',
      data
    })
    return response
  },
  async GetProductPackageList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/GetProductPackage',
      type: 'get',
      data
    })
    return response
  },
  async GetProductPackageForOrder(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/GetProductPackageForOrder',
      type: 'get',
      data
    })
    return response
  },
  async CreateProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/Create',
      type: 'post',
      data
    })
    return response
  },
  async UpdateProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/Update',
      type: 'post',
      data
    })
    return response
  },
  async GetProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/GetById',
      type: 'get',
      data
    })
    return response
  },
  async ActiveProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  
  async SetProductSalesInFront(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/IsSalesInFront',
      type: 'post',
      data
    })
    return response
  },
  
  async BatchSetNewProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/BatchSetNewProduct',
      type: 'post',
      data
    })
    return response
  },
    
  async BatchSetActivityProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/BatchSetActivityProduct',
      type: 'post',
      data
    })
    return response
  },
  async SetProductIsActivity(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/SetActivityProduct',
      type: 'post',
      data
    })
    return response
  },
  async SetProductIsNew(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/SetNewProduct',
      type: 'post',
      data
    })
    return response
  },
  //批量上架
  async batchShelfProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/BatchIsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  //批量前台销售
  async batchSaleShelfProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/BatchIsSalesInFront',
      type: 'post',
      data
    })
    return response
  },
  
  async batchIsAllowSplit(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Product/BatchAllowSplit',
      type: 'post',
      data
    })
    return response
  },
  // 价格
  async GetSalesPriceList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/SalesPrice/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetSalesPriceHistoryList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/SalesPriceHistory/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetSalesPriceForOrder(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/SalesPrice/GetSalesPriceForOrder',
      type: 'get',
      data
    })
    return response
  },
  // 促销活动
  async DelPromotionActivity(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionActivity/Delete',
      type: 'post',
      data
    })
    return response
  },
  async CreateOrUpdatePromotionActivity(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionActivity/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async GetPromotionActivityList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionActivity/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetPromotionActivitySelectList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionActivity/GetSelectPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetPromotionActivity(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionActivity/GetById',
      type: 'get',
      data
    })
    return response
  },
  async BatchPublishPromotionActivity(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionActivity/BatchPublish',
      type: 'post',
      data
    })
    return response
  },
  async CancelPromotionActivity(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionActivity/Cancel',
      type: 'post',
      data
    })
    return response
  },
  async GetPromotionActivityForOrder(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionActivity/GetPromotionActivityForOrder',
      type: 'get',
      data
    })
    return response
  },
  // 促销产品
  async DelPromotionProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionProduct/Delete',
      type: 'post',
      data
    })
    return response
  },
  async CreateOrUpdatePromotionProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionProduct/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async GetPromotionProductList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionProduct/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetPromotionProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionProduct/GetById',
      type: 'get',
      data
    })
    return response
  },
  // 促销范围
  async DelPromotionScope(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionScope/Delete',
      type: 'post',
      data
    })
    return response
  },
  async CreateOrUpdatePromotionScope(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionScope/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async GetPromotionScopeList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/PromotionScope/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  // 促销套装
  async GetBomProductList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetBomProductOrgList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/GetProductOrgPaged',
      type: 'get',
      data
    })
    return response
  },
  async GetBomProductPackageList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/GetProductPackage',
      type: 'get',
      data
    })
    return response
  },
  async CreateBomProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/Create',
      type: 'post',
      data
    })
    return response
  },
  async UpdateBomProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/Update',
      type: 'post',
      data
    })
    return response
  },
  async DeleteBomProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/Delete',
      type: 'post',
      data
    })
    return response
  },
  async GetBomProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/GetById',
      type: 'get',
      data
    })
    return response
  },
  async ActiveBomProduct(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async SetBomProductSalesInFront(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/IsSalesInFront',
      type: 'post',
      data
    })
    return response
  },
  async DeleteBomProductOrg(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/DeleteOrg',
      type: 'post',
      data
    })
    return response
  },
  async GetProductOrganizationListForUpdate(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/GetProductOrganizationListForUpdate',
      type: 'get',
      data
    })
    return response
  },
  async UpdateBomProductOrganization(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/BomProduct/UpdateProductOrganization',
      type: 'post',
      data
    })
    return response
  },
  // 组合
  async GetProductUnionList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductUnion/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetProductUnion(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductUnion/GetById',
      type: 'get',
      data
    })
    return response
  },
  async AddOrUpdateProductUnion(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductUnion/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async DelProductUnion(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductUnion/Delete',
      type: 'post',
      data
    })
    return response
  },
  async ActiveProductUnion(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductUnion/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  //组合明细
  async GetProductUnionItemList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductUnion/GetItemPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetProductUnionItem(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductUnion/GetItemById',
      type: 'get',
      data
    })
    return response
  },
  async AddOrUpdateProductUnionItem(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductUnion/CreateOrUpdateItem',
      type: 'post',
      data
    })
    return response
  },
  async DelProductUnionItem(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ProductUnion/DeleteItem',
      type: 'post',
      data
    })
    return response
  },
}
export default product



// WEBPACK FOOTER //
// ./src/common/api/product.js